<template>
  <div class="inner-box">
    <div slot="content">
      <el-form size="medium" @submit.prevent="save">
        <div class="content-name">
          <h2 class="dp-ib">{{ routeName }}</h2>
          <el-form-item label-width="0px" style="float: right;">
            <el-button type="primary" icon="el-icon-search" @click="goOpen">
              {{ this.$i18n.messages[this.$store.state.locale].search }}
            </el-button>
            <el-button type="success" icon="el-icon-document-checked" @click="excelDown">엑셀</el-button>
          </el-form-item>
        </div>
      </el-form>

      <div class="search-form">
        <el-form size="mini">
          <el-row style="margin-bottom: 0px;">
            <el-col :span="10">
              <el-form-item label-width="0px">
                <el-row>
                  <el-col>
                    <el-form-item label="접수기간">
                      <el-col :span="9">
                        <el-date-picker type="date" placeholder="시작일" v-model="form.startDt" style="width: 90%;" value-format="yyyy-MM-dd"></el-date-picker>
                      </el-col>
                      <el-col :span="1" style="text-align: start;">-</el-col>
                      <el-col :span="10">
                        <el-date-picker type="date" placeholder="종료일" v-model="form.endDt" style="width: 90%;" value-format="yyyy-MM-dd"></el-date-picker>
                      </el-col>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="배정구분" label-width="100px">
                <el-select v-model="form.allocationYn">
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['allocationType']"
                      :key="item.key"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="접수유형" label-width="100px">
                <el-select v-model="form.asClass">
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['asClass']"
                      :key="item.key"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="접수상담원" label-width="100px">
                <el-select v-model="form.userEmpSelAll">
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['userEmpSelAll']"
                      :key="item.key"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 0px;">
            <el-col :span="6">
              <el-form-item label="고객구분">
                <el-select v-model="form.custType">
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['custType']"
                      :key="item.key"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="18">
              <el-form-item :label="$i18n.messages[$store.state.locale].siteNm" label-width="134px">
                <el-row>
                  <el-col :span="6">
                    <el-input type="text" v-model="form.siteNm1" @keyup.native.enter="goOpen"></el-input>
                  </el-col>
                  <el-col :span="6">
                    <el-input type="text" v-model="form.siteNm2" @keyup.native.enter="goOpen"></el-input>
                  </el-col>
                  <el-col :span="6">
                    <el-input type="text" v-model="form.siteNm3" @keyup.native.enter="goOpen"></el-input>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 0px;">
            <el-col :span="12">
              <el-form-item label="지역/센터">
                <el-select v-model="form.areaAgent" @change="onAreaAgentChange">
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['areaAgent']"
                      :key="item.value"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
                <el-select v-model="form.subAreaAgent" v-show="changeCatIdShow">
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['subAreaAgent']"
                      :key="item.value"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="처리결과">
                <el-col :span="16">
                  <el-select v-model="form.asStatus">
                    <el-option value='' label="전체">전체</el-option>
                    <el-option
                        v-for="item in combos['asStatus']"
                        :key="item.value"
                        :value="item.key"
                        :label="item.value">
                    </el-option>
                  </el-select>
                </el-col>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="오늘의 할 일">
                <el-col :span="16">
                  <el-checkbox type="text" true-label="Y" false-label="N"  v-model="form.todayWork"></el-checkbox>
                </el-col>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>

    <div class="table-area">
      <div class="table-b">
        <div class="table-header">
          <div class="grid-tbl-box">
            <ag-grid-vue
                ref="grid"
                :style="gridStyle"
                class="ag-theme-alpine"
                :enableRangeSelection="true"
                :column-defs="columnDefs"
                :grid-options="mainGridOptions"
                :row-data="data"
                :default-col-def="defaultColDef"
                :framework-components="frameworkComponent"
                :statusBar="statusBar"
                @grid-ready="onReadyMain"
                @cell-clicked="onCellClicked" />
          </div>

          <div class="grid-tbl-box" v-show="false">
              <ag-grid-vue 
                  ref="excelGrid" 
                  :style="gridStyle"
                  class="ag-theme-alpine"
                  :enableRangeSelection="true"
                  :column-defs="excelColumnDefs"
                  :grid-options="excelGridOptions"
                  :row-data="excelData"
                  :default-col-def="defaultColDef"
                  :framework-components="frameworkComponent"
                  @grid-ready="onReadyExcel"
                  />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DatepickerCellRenderer from "@/components/agGrid/datepicker-cell-renderer";
import MaskEditCellRenderer from "@/components/agGrid/maskedit-cell-renderer";
import SelectCellRenderer from "@/components/agGrid/select-cell-renderer";
import CheckboxCellRenderer from "@/components/agGrid/checkbox-cell-renderer";
import RadioCellRenderer from "@/components/agGrid/radio-cell-renderer";
import NumberInputCellRender from "@/components/agGrid/numberinput-cell-renderer";
import InputCellRender from "@/components/agGrid/input-cell-renderer";
import ButtonCellRenderer from "@/components/agGrid/button-cell-renderer";

function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}


function _phone(hp){
    return hp ? hp.replace(/[^0-9]/g, "").replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/, "$1-$2-$3" ) : ''
}


export default {
  props: {
  },
  data() {
    return {
      data: [],
      excelData: [],
      form: {
        companyId : '',
        startDt: this.$moment().add(-1, 'month').startOf('month').format('YYYY-MM-DD'),
        endDt: this.$moment().format('YYYY-MM-DD'),
        allocationYn : '',        /** 배정구분 */
        asClass: '',              /** 접수유형 */
        custType : '',            /** 고객구분 */
        areaAgent : '',           /** 지역/센터 */
        subAreaAgent: '',
        asStatus : '',            /** 처리결과 */    
        callType: '',
        siteType: '',
        catId: 0,
        creatorId: 0,
        callStatus: '',            // 처리결과
        userEmpSelAll: '',         // 접수상담원
        custType : '',             // 고객구분
        siteNm1 : '',              // 사이트명1
        siteNm2 : '',              // 사이트명2
        siteNm3 : '',              // 사이트명3
        sortType :  '',
        todayWork : '',
        processTime : '',
        page: 1,
        totalpage: 9999,
        totalcount: 9999,
        curPage: 0,
        processTime: ''
      },
      combos: {
        'allocationType': [], /** 배정구분 */
        'asClass': [], /** 접수유형 */
        'asClass2': [], /** 접수유형 2 LEVEL */
        'asClass3': [], /** 접수유형 3 LEVEL */
        'userEmpSelAll' : [], /** 접수상담원 */
        'custType' : [], /** 고객구분 */
        'areaAgent': [], /** 지역/센터 */
        'subAreaAgent' : [],
        'asStatus' : [] /** 처리결과 */
      },
      changeCatIdShow: false,
      startDt: this.$moment().add(-1, 'month').startOf('month').format('YYYY-MM-DD'),
      endDt: this.$moment().format('YYYY-MM-DD'),
      // AG-GRID OPTION [START]
      gridStyle : 'padding-top: 20px; width: 100%;height: 700px; min-height:100px;',
      defaultColDef: {
          resizable: true
        , filter:true
        , sortable: true
      },
      mainGridApi: null,
      mainColumnApi: null,
      mainGridOptions: {
        enableColResize: true,
        enableFilter: true,
        animateRows: false,
        enableSorting: true,
      },
      excelGridApi: null,
      excelColumnApi: null,
      excelGridOptions: {
        enableColResize: true,
        enableFilter: true,
        animateRows: false,
        enableSorting: true,

        excelStyles: [
          {
              id: 'numberType',
              numberFormat: {
                  format: '0',
              },
          },
          {
              id: 'stringType',
              dataType: 'String',
          },
          {
              id: 'dateType',
              dataType: 'DateTime',
          },
        ],
      },
      columnDefs: [],
      excelColumnDefs: [],
      frameworkComponent : {
        datePicker: DatepickerCellRenderer,
        maskEdit: MaskEditCellRenderer,
        select: SelectCellRenderer,
        checkBox: CheckboxCellRenderer,
        radio: RadioCellRenderer,
        numberInput: NumberInputCellRender,
        input: InputCellRender,
        button: ButtonCellRenderer
      },
      statusBar: null,
    }
  },
  methods: {
    onReadyMain() {
      this.mainGridApi = this.mainGridOptions.api;
      this.mainColumnApi = this.mainGridOptions.columnApi;

      this.init();
    },
    onReadyExcel() {
      this.excelGridApi = this.excelGridOptions.api;
      this.excelColumnApi = this.excelGridOptions.columnApi;
    },
    createMainColumnDefs() {
      this.columnDefs = [
        {
          headerName:'No',
          field:'no',
          width:80,
          cellStyle:{textAlign: 'center'}
        },
        {headerName:'접수일시', field:'callDt', width:180, cellStyle:{textAlign: 'center'}},
        {headerName:'접수유형/세부유형', field:'asClassNm', width:150, cellStyle:{textAlign: 'center'}},
        {headerName:'고객구분', field:'custType', width:100, cellStyle:{textAlign: 'center'}},
        {headerName:'사이트', field:'siteNm', width:100, cellStyle:{textAlign: 'center'}},
        {headerName:'신고자명', field:'boundCustNm', width:150, cellStyle:{textAlign: 'center'},
          cellRenderer: (params) => {
            return `<div style="text-decoration: underline; text-underline-position: under; color:blue; cursor:pointer;">${params.value}</div>`;
          }},
        {headerName:'전화번호', field:'telNo', width:150, cellStyle:{textAlign: 'center'}},
        {headerName:'핸드폰', field:'hpNo', width:150, cellStyle:{textAlign: 'center'}},
        {headerName:'모델CD', field:'modelCd', width:150, hide: true},
        {headerName:'모델', field:'modelNm', width:150, cellStyle:{textAlign: 'center'}},
        {headerName:'대수', field:'modelQty', width:80, cellStyle:{textAlign: 'center'}},
        {headerName:'장애증상', field:'asCatNm', width:150, cellStyle:{textAlign: 'left'}},
        {headerName:'접수센터', field:'createAsAgentNm', width:150, cellStyle:{textAlign: 'center'}},
        {headerName:'처리센터', field:'allocationAsAgentNm', width:150, cellStyle:{textAlign: 'center'}},
        {headerName:'처리결과', field:'asStatusNm', width:150, cellStyle:{textAlign: 'center'}},
        {headerName:'접수자', field:'creatorNm', width:150, cellStyle:{textAlign: 'center'}}
      ];
    },
    createExcelColumnDefs() {
      const vm = this;
      this.excelColumnDefs = [
      {
          headerName:'No',
          field:'no',
          width:80,
          cellStyle:{textAlign: 'center'}
        },
        {headerName:'접수일시', field:'callDt', width:180, cellStyle:{textAlign: 'center'}},
        {headerName:'접수유형/세부유형', field:'asClassNm', width:150, cellStyle:{textAlign: 'center'}},
        {headerName:'고객구분', field:'custType', width:150, cellStyle:{textAlign: 'center'}},
        {headerName:'사이트', field:'siteNm', width:200, cellStyle:{textAlign: 'center'}},
        {headerName:'신고자명', field:'boundCustNm', width:180, cellStyle:{textAlign: 'center'}},
        {headerName:'신고자전화번호', field:'asTelNo', width:150, cellStyle:{textAlign: 'center'}},
        {headerName:'신고자전화번호(1)', field:'telNo', width:150, cellStyle:{textAlign: 'center'}},
        {headerName:'제조사', field:'makerNm', width:150, cellStyle:{textAlign: 'center'}},
        {headerName:'제품군', field:'modelGroupNm', width:150, cellStyle:{textAlign: 'center'}},
        {headerName:'대표모델', field:'standardModelNm', width:150, cellStyle:{textAlign: 'center'}},
        {headerName:'모델', field:'modelNm', width:150, cellStyle:{textAlign: 'center'}},
        {headerName:'대수', field:'modelQty', width:100, cellStyle:{textAlign: 'center'}},
        {headerName:'장애증상', field:'asCatNm', width:150, cellStyle:{textAlign: 'center'}},
        {headerName:'상세증상', field:'asCatDescription', width:250, cellStyle:{textAlign: 'center'}},
        {headerName:'고객 요구사항', field:'callMemo', width:250, cellStyle:{textAlign: 'center'}},
        {headerName:'특이사항', field:'visitMemo', width:250, cellStyle:{textAlign: 'center'}},
        {headerName:'접수센터', field:'createAsAgentNm', width:150, cellStyle:{textAlign: 'center'}},
        {headerName:'처리센터', field:'allocationAsAgentNm', width:150, cellStyle:{textAlign: 'center'}},
        {headerName:'처리결과', field:'asStatusNm', width:150, cellStyle:{textAlign: 'center'}},
        {headerName:'요청일시', field:'requestVisitDt', width:150, cellStyle:{textAlign: 'center'}},
        {headerName:'처리일시', field:'procDt', width:150, cellStyle:{textAlign: 'center'}},
        {headerName:'접수자', field:'creatorNm', width:150, cellStyle:{textAlign: 'center'}}
      ];
    },
    onCellClicked(params) {
      //const idx = params.rowIndex;
      const field = params.colDef.field;
      console.log('onCellClicked params : ', params)
      if(field === 'boundCustNm') {
        this.$router.push({          
                path: '/callMain',
                query: {
                  AS_ID : params.data.asId,
                }
            })    
      }
    },
    
    $dismiss() {
      this.$emit('dismiss')
      this.$parent.close()
    },
    goOpen() {
      this.form.catId = 0;
      
      const aEmpKey = this.form.userEmpSelAll.split(',');
      if(aEmpKey && aEmpKey.length>0){
        this.form.creatorId = aEmpKey[1] || '0';
      } else {
        this.form.creatorId = '0';
      }
    
      this.form.siteType = this.form.custType === '' ? '' : this.form.custType;
      
      let vCatId = this.form.subAreaAgent || '0';
      if(vCatId === '0'){
        const vAreaAgent2Obj = this.combos['areaAgent'].filter(x=>x.catKey===this.form.areaAgent);
        vCatId = vAreaAgent2Obj && vAreaAgent2Obj.length>0 ? vAreaAgent2Obj[0].catId : '0';
      }
      
      const vForm = {
        ...this.form,
        catId : vCatId
      }

      if(vForm && (vForm.startDt == null || vForm.startDt == '')){
        vForm.startDt = '2000-01-01';
      }

      if(vForm && (vForm.endDt == null || vForm.endDt == '')){
        vForm.endDt = '2100-12-31';
      }

      console.log('goOpen passed vForm: ', vForm);

      this.$store.commit('loading')

      this.$http.post(_url("/api/asMng/popup/asCallList"), vForm).then(response => {
        console.log('response.data' , response.data)
        this.data = response.data.map((x,index)=>{
          x.no = index+1;
          const vObj = this.combos['custType'].filter(y=>y.key === x.custType).map(z=>{return z.value}) ;
          x.callDt = x.callDt && x.callDt.length >= 19 ? x.callDt.substring(0,19) : '';
          x.custType = vObj && vObj.length>0 ? vObj[0] : '';
          x.boundTelNo = _phone(x.boundTelNo);
          x.telNo = _phone(x.telNo);
          x.hpNo = _phone(x.hpNo);
          x.siteNm1 = x.siteNm1 ? x.siteNm1 : '';
          x.siteNm2 = x.siteNm2 ? x.siteNm2 : '';
          x.siteNm3 = x.siteNm3 ? x.siteNm3 : '';
          x.siteNm = x.siteNm1 + ' ' + x.siteNm2 + ' ' + x.siteNm3;

          const vAsClass3Obj = this.combos['asClass3'].filter(y=>y.catKey===x.asClass);
          const asClassNm3 = vAsClass3Obj && vAsClass3Obj.length>0 ? vAsClass3Obj[0].catNm : '';

          if(asClassNm3 && asClassNm3 === ''){
            const vAsClass2Obj = this.combos['asClass2'].filter(y=>y.catKey===x.asClass);
            const asClassNm2 = vAsClass2Obj && vAsClass2Obj.length>0 ? vAsClass2Obj[0].catNm : '';

            x.asClassNm = asClassNm2 ;
          } else {
            const parentId3 = vAsClass3Obj && vAsClass3Obj.length>0 ? vAsClass3Obj[0].parentId : '';
            const vAsClass2Obj = this.combos['asClass2'].filter(y=>y.catId===parentId3);
            const asClassNm2 = vAsClass2Obj && vAsClass2Obj.length>0 ? vAsClass2Obj[0].catNm : '';

            x.asClassNm = asClassNm2 + '/' + asClassNm3;
          } 
          
          const vAsStatusObj = this.combos['asStatus'].filter(y=>y.key===x.asStatus);
          x.asStatusNm = vAsStatusObj && vAsStatusObj.length>0 ? vAsStatusObj[0].value : '';

          if(x.asStatus && x.asStatus != '' && x.asStatusNm == ''){
            const vAsStatusObj3 = this.combos['asStatus3'].filter(y=>y.catKey==x.asStatus);
            x.asStatusNm = vAsStatusObj3 && vAsStatusObj3.length>0 ? vAsStatusObj3[0].catNm : '';
          }

          return x;
        })

      }).finally(() => {
        this.$store.commit('finish')
      });
    },
    save() {
      console.log('test',this.$parent.$refs.step.next())
    },
    excelDown(){
      this.$store.commit('loading')

      // let vStartDt = this.form.startDt ? this.form.startDt.replace(/[^0-9]/g, '') : '';
      // let vEndDt = this.form.endDt ? this.form.endDt.replace(/[^0-9]/g, '') : '';

      let vCatId = this.form.subAreaAgent || '0';
      if(vCatId === '0'){
        const vAreaAgent2Obj = this.combos['areaAgent'].filter(x=>x.catKey===this.form.areaAgent);
        vCatId = vAreaAgent2Obj && vAreaAgent2Obj.length>0 ? vAreaAgent2Obj[0].catId : '0';
      }

      const vform = {
        ...this.form,
        creatorId : this.form.creatorId == '' ? '0' : this.form.creatorId,
        catId : vCatId
      }

      console.log('excelDown pass vform: ', vform);
      this.form.deliveryNoCount = 0; //초기화
      this.$http.post(_url("/api/asMng/call/selectExcelItem"), vform).then(response => {
        console.log('excelDown response.data' , response.data)
        this.excelData = response.data.map((x, index)=>{
          x.no = index + 1;

          const vObj = this.combos['custType'].filter(y=>y.key === x.custType).map(z=>{return z.value}) ;
          x.callDt = x.callDt && x.callDt.length >= 19 ? x.callDt.substring(0,19) : '';
          x.procDt = x.procDt && x.procDt.length >= 19 ? x.procDt.substring(0,19) : '';
          
          x.custType = vObj && vObj.length>0 ? vObj[0] : '';
          x.boundTelNo = _phone(x.boundTelNo);
          x.asTelNo = _phone(x.asTelNo);
          x.telNo = _phone(x.telNo);
          x.hpNo = _phone(x.hpNo);
          x.siteNm1 = x.siteNm1 ? x.siteNm1 : '';
          x.siteNm2 = x.siteNm2 ? x.siteNm2 : '';
          x.siteNm3 = x.siteNm3 ? x.siteNm3 : '';
          x.siteNm = x.siteNm1 + ' ' + x.siteNm2 + ' ' + x.siteNm3;

          x.createDt = x.createDt && x.createDt.length>=10 ? x.createDt.substring(0,10) : '';
          
          const vAsClass3Obj = this.combos['asClass3'].filter(y=>y.catKey===x.asClass);
          const asClassNm3 = vAsClass3Obj && vAsClass3Obj.length>0 ? vAsClass3Obj[0].catNm : '';

          if(asClassNm3 && asClassNm3 === ''){
            const vAsClass2Obj = this.combos['asClass2'].filter(y=>y.catKey===x.asClass);
            const asClassNm2 = vAsClass2Obj && vAsClass2Obj.length>0 ? vAsClass2Obj[0].catNm : '';

            x.asClassNm = asClassNm2 ;
          } else {
            const parentId3 = vAsClass3Obj && vAsClass3Obj.length>0 ? vAsClass3Obj[0].parentId : '';
            const vAsClass2Obj = this.combos['asClass2'].filter(y=>y.catId===parentId3);
            const asClassNm2 = vAsClass2Obj && vAsClass2Obj.length>0 ? vAsClass2Obj[0].catNm : '';

            x.asClassNm = asClassNm2 + '/' + asClassNm3;
          } 
          
          const vAsStatusObj = this.combos['asStatus'].filter(y=>y.key===x.asStatus);
          x.asStatusNm = vAsStatusObj && vAsStatusObj.length>0 ? vAsStatusObj[0].value : '';

          if(x.asStatus && x.asStatus != '' && x.asStatusNm == ''){
            const vAsStatusObj3 = this.combos['asStatus3'].filter(y=>y.catKey==x.asStatus);
            x.asStatusNm = vAsStatusObj3 && vAsStatusObj3.length>0 ? vAsStatusObj3[0].catNm : '';
          }
          
          return x;
        }); 

      }).finally(() => {
        this.$store.commit('finish');

        var params = {
          fileName : "AS접수리스트"
        };
        this.excelGridOptions.api.exportDataAsExcel(params);

      });
      
    },
    async init() {
      this.$store.commit('loading');
      await this.$http.post(`/api/asMng/asCallList/init`)
          .then(response => {
            console.log('asCallList response.data : ', response.data);
            
            this.combos['allocationType'] = response.data.allocationType; // 배정구분
            this.combos['asClass'] = response.data.asClass.filter(x=>x.catLvl===2).map(x=>{x.key=x.catKey; x.value=x.catNm; return x; });
            this.combos['asClass2'] = response.data.asClass.filter(x=>x.catLvl===2);
            this.combos['asClass3'] = response.data.asClass.filter(x=>x.catLvl===3);
            console.log('asCallList asClass2, asClass3 : ', this.combos['asClass2'], this.combos['asClass3']);
            
            this.combos['userEmpSelAll'] = response.data.userEmpSelAll;
            this.combos['custType'] = response.data.custType;
            this.combos['areaAgent'] = response.data.areaAgent.map(x=>{x.key=x.catKey; x.value=x.catNm; return x; });

            this.combos['asStatus'] = response.data.asStatus.filter(x=>x.catLvl===2).map(x=>{x.key=x.catKey; x.value=x.catNm; return x; });
            this.combos['asStatus3'] = response.data.asStatus.filter(x=>x.catLvl===3);
            
            this.form.callStatus = 'Receipt'

            if(this.$store.state.loginInfo.groupUId==3 || this.$store.state.loginInfo.groupUId==6) {
              this.form.userEmpSelAll = this.$store.state.loginInfo.loginId + ',' + this.$store.state.loginInfo.id;
            } 

          }).finally(() => {
            //this.goOpen();
            this.$store.commit('finish');
            this.goOpen();
          });

      this.createMainColumnDefs();
      this.createExcelColumnDefs();
    },
    onAreaAgentChange(param){
        // 지역/센터 변경시
 
        this.form.subAreaAgent = '';
        if(param === '') this.changeCatIdShow =  false;
        else{
          this.changeCatIdShow =  true;
console.log('onAreaAgentChange', param, this.combos['areaAgent']);
          const vCatObj = this.combos['areaAgent'].filter(x=>x.catKey===param);
          let vCatId = '';
          if(vCatObj && vCatObj.length>0){
              vCatId = vCatObj[0].catId;
          }

          // 하위 지역/센터 : AreaAgent, CAT_LVL(3)
            const vform = {
                companyId: this.$store.state.loginInfo.compCd, 
                parentId: vCatId,
                child1: '',
                child1Col: 'C',
                child2: '',
                child3: '',
                searchFlag: 'AS_USER'
            }
            
            this.$http.get(`/api/asMng/call/combo`, {params: vform})
              .then(response => {
                  const respCombo = response.data.getComboList;
                  const respAsuser = response.data.getAsUserList || [];

                  this.combos['subAreaAgent'] = respCombo
                      .filter(z=>z.contractStatus != 'N')
                      .map(y=>{
                          y.key = y.catId
                          y.value = '[' + y.catKey + ']' + y.catNm
                          
                          return y
                      }) || [];
                });
        }
    },

  },
  created() {

    if(this.$route.query.startDt == 'TodayComplete'){
      this.form.startDt = this.$moment().format('YYYY-MM-DD');
      // this.form.allocationYn = 'N'; //배정구분 전체로 변경 요청하여 data() 에서 초기 렌더링 시 전체 (form.allocationYn : '') 로 체크되어 있기 때문에 주석함. by jaykim.
      this.form.todayWork = 'N';
    }else if(this.$route.query.startDt == 'TodayWork'){
      this.form.startDt = '';
      // this.form.allocationYn = ''; //위 처리와 동일하게 달리 설정할 필요 없기 때문에 주석처리함. by jaykim.
      this.form.todayWork = 'Y';
    }

    this.statusBar = {
      statusPanels: [
        { statusPanel: 'agTotalRowCountComponent', align: 'right' },
      ],
    };
  },
  mounted() {
    console.log('search', this.search);
    this.form.companyId = this.$store.state.loginInfo.compCd;
    
  },
  computed: {
    routeName() {
      return this.$route.name
    }
  },
}
</script>


<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
</style>